import { render, staticRenderFns } from "./GatFieldSpacer.vue?vue&type=template&id=c12e4fce&scoped=true"
import script from "./GatFieldSpacer.vue?vue&type=script&lang=js"
export * from "./GatFieldSpacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12e4fce",
  null
  
)

export default component.exports